"use strict";

var _defineProperty = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var http = require("http");

var https = require("https");

var _require = require("url"),
    parseURLToNodeOptions = _require.parse;

var HttpProxyAgent = require("http-proxy-agent");

var HttpsProxyAgent = require("https-proxy-agent");

module.exports = function agentFactory(proxy, rejectUnauthorized) {
  var agentOpts = {
    keepAlive: true,
    rejectUnauthorized: rejectUnauthorized
  };

  if (proxy) {
    var proxyOpts = _objectSpread({}, parseURLToNodeOptions(proxy), {}, agentOpts);

    return {
      https: new HttpsProxyAgent(proxyOpts),
      http: new HttpProxyAgent(proxyOpts)
    };
  }

  return {
    http: new http.Agent(agentOpts),
    https: new https.Agent(agentOpts)
  };
};